module.exports = __webpack_public_path__ + "media/bootstrap-icons/columns-6161f00f.svg";